var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { alpha } from '@mui/material/styles';
import { chipClasses } from '@mui/material/Chip';
// ----------------------------------------------------------------------
var COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
// ----------------------------------------------------------------------
export function chip(theme) {
    var lightMode = theme.palette.mode === 'light';
    var rootStyles = function (ownerState) {
        var _a, _b, _c, _d, _e;
        var defaultColor = ownerState.color === 'default';
        var filledVariant = ownerState.variant === 'filled';
        var outlinedVariant = ownerState.variant === 'outlined';
        var softVariant = ownerState.variant === 'soft';
        var defaultStyle = __assign((_a = {}, _a["& .".concat(chipClasses.deleteIcon)] = {
            opacity: 0.48,
            color: 'currentColor',
            '&:hover': {
                opacity: 1,
                color: 'currentColor'
            }
        }, _a), (defaultColor && __assign(__assign(__assign((_b = {}, _b["& .".concat(chipClasses.avatar)] = {
            color: theme.palette.text.primary
        }, _b), (filledVariant && (_c = {
                color: lightMode ? theme.palette.common.white : theme.palette.grey[800],
                backgroundColor: theme.palette.text.primary,
                '&:hover': {
                    backgroundColor: lightMode ? theme.palette.grey[700] : theme.palette.grey[100]
                }
            },
            _c["& .".concat(chipClasses.icon)] = {
                color: lightMode ? theme.palette.common.white : theme.palette.grey[800]
            },
            _c))), (outlinedVariant && {
            border: "solid 1px ".concat(alpha(theme.palette.grey[500], 0.32))
        })), (softVariant && {
            color: theme.palette.text.primary,
            backgroundColor: alpha(theme.palette.grey[500], 0.16),
            '&:hover': {
                backgroundColor: alpha(theme.palette.grey[500], 0.32)
            }
        }))));
        var colorStyle = COLORS.map(function (color) {
            var _a;
            return (__assign({}, (ownerState.color === color && __assign((_a = {}, _a["& .".concat(chipClasses.avatar)] = {
                color: theme.palette[color].lighter,
                backgroundColor: theme.palette[color].dark
            }, _a), (softVariant && {
                color: theme.palette[color][lightMode ? 'dark' : 'light'],
                backgroundColor: alpha(theme.palette[color].main, 0.16),
                '&:hover': {
                    backgroundColor: alpha(theme.palette[color].main, 0.32)
                }
            })))));
        });
        var disabledState = (_d = {},
            _d["&.".concat(chipClasses.disabled)] = __assign(__assign(__assign((_e = { opacity: 1, color: theme.palette.action.disabled }, _e["& .".concat(chipClasses.icon)] = {
                color: theme.palette.action.disabled
            }, _e["& .".concat(chipClasses.avatar)] = {
                color: theme.palette.action.disabled,
                backgroundColor: theme.palette.action.disabledBackground
            }, _e), (filledVariant && {
                backgroundColor: theme.palette.action.disabledBackground
            })), (outlinedVariant && {
                borderColor: theme.palette.action.disabledBackground
            })), (softVariant && {
                backgroundColor: theme.palette.action.disabledBackground
            })),
            _d);
        return __spreadArray(__spreadArray([
            defaultStyle
        ], __read(colorStyle), false), [
            disabledState,
            {
                fontWeight: 500,
                borderRadius: theme.shape.borderRadius
            }
        ], false);
    };
    return {
        MuiChip: {
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return rootStyles(ownerState);
                }
            }
        }
    };
}
